var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 16 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33301 2.39967C1.33301 2.02631 1.33301 1.83962 1.40567 1.69701C1.46959 1.57157 1.57157 1.46959 1.69701 1.40567C1.83962 1.33301 2.02631 1.33301 2.39967 1.33301H13.5997C13.973 1.33301 14.1597 1.33301 14.3023 1.40567C14.4278 1.46959 14.5298 1.57157 14.5937 1.69701C14.6663 1.83962 14.6663 2.02631 14.6663 2.39967V2.84594C14.6663 3.02513 14.6663 3.11473 14.6444 3.19805C14.625 3.27188 14.5931 3.34183 14.55 3.40485C14.5014 3.47596 14.4337 3.53464 14.2983 3.65201L10.0344 7.34734C9.899 7.46471 9.83129 7.52339 9.78267 7.5945C9.73958 7.65752 9.70764 7.72747 9.68824 7.8013C9.66634 7.88462 9.66634 7.97421 9.66634 8.15341V11.6386C9.66634 11.769 9.66634 11.8342 9.64531 11.8905C9.62673 11.9403 9.59652 11.9849 9.55718 12.0207C9.51266 12.0611 9.45213 12.0854 9.33108 12.1338L7.06442 13.0404C6.81939 13.1385 6.69687 13.1875 6.59852 13.167C6.51252 13.1492 6.43704 13.0981 6.38851 13.0248C6.33301 12.9411 6.33301 12.8092 6.33301 12.5453V8.15341C6.33301 7.97421 6.33301 7.88462 6.31111 7.8013C6.29171 7.72747 6.25977 7.65752 6.21668 7.5945C6.16806 7.52339 6.10035 7.46471 5.96493 7.34734L1.70108 3.65201C1.56566 3.53464 1.49796 3.47596 1.44934 3.40485C1.40625 3.34183 1.37431 3.27188 1.35491 3.19805C1.33301 3.11473 1.33301 3.02513 1.33301 2.84594V2.39967Z",
    stroke: "#F7F9F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.7a0ae256d6cac5299f87781d966c35b3.svg";
export { ForwardRef as ReactComponent };